//
//
//
//
//
//
//
//
//
//
//

import { isGoLogin } from '../util'

export default {
  methods: {
    goChat: function () {
      if (isGoLogin(this)) {
        // window.open('http://p.qiao.baidu.com/cps/chat?siteId=12052193&userId=25589247')
        this.$router.push('chat')
      }
    }
  },
  computed: {
    loginFlag: function () {
      return this.$store.state.user.isLogin
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/footer.vue